import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService, ApiUrlConstants, LoaderService } from '../../../../shared/utils/imports';

@Component({
  selector: 'app-company-filter',
  templateUrl: './company-filter.component.html'
})
export class CompanyFilterComponent implements OnInit {
  @Input() dropdownFilterCompany;
  @Output() companyFilterOutput = new EventEmitter();
  public showList;
  public companyList = [];
  constructor(
    private readonly api: ApiService,
    public readonly loader: LoaderService
  ) {
    this.getCompanyList();
  }
  ngOnInit() {
    this.showList = this.dropdownFilterCompany.show;
  }
  /* fn trigeered when selecting any value in dropdown */
  public clearFilter() {
    this.dropdownFilterCompany.CompanyName = 'ALL';
    this.dropdownFilterCompany.CompanyId = null;
    this.dropdownFilterCompany.IsCompanyDisplay = null;
    this.companyFilterOutput.next('clear');
  }
  /* fn trigeered when selecting any value in dropdown */
  public dropdownSelect(item) {
    this.dropdownFilterCompany.CompanyName = item.CompanyName;
    this.dropdownFilterCompany.CompanyId = item.CompanyId;
    this.dropdownFilterCompany.IsCompanyDisplay = item.IsCompanyDisplay;
    this.companyFilterOutput.next(item);
  }
  /* hide the dropdown clicking outside */
  public dropdownClickOutside(event) {
    this.dropdownFilterCompany.show = false;
  }
  /* get the list of companies */
  private getCompanyList() {
    this.loader.startLoader();
    const url = ApiUrlConstants.URL.companiesListURL;
    this.companyList = [];
    this.api.ExecuteGet(url, (response) => {
      if (response.Data && response.Data.length) {
        this.companyList = response.Data;
      }
      this.loader.stopLoader();
    }, (error) => {
      this.loader.stopLoader();
    });
  }

}
